export default "__VITE_ASSET__a7b2679c__"